/**
 * ServiceTechniqueTabs.tsx — barre d'onglets du module Service technique.
 *
 * Depuis le fix nav mobile (juillet 2026), ce composant délègue au nav partagé
 * `ServiceTechniqueNav` (flex-wrap, menu déroulant Planning/Présence, plus
 * d'overflow-x-auto). Conserve son ancienne signature (`active`, `right`) pour
 * ne pas casser les pages appelantes (Présence, Équipes).
 */

import { ServiceTechniqueNav, type ServiceTechniqueNavKey } from '@/components/ServiceTechniqueNav';

export type STTab = 'planning' | 'presence' | 'incidents' | 'arretes' | 'vehicules' | 'materiel';

export function ServiceTechniqueTabs({ active, right }: { active: STTab; right?: React.ReactNode }) {
  return (
    <nav
      aria-label="Navigation Service technique"
      className="border-b border-border backdrop-blur-glass px-4 py-2"
      style={{ backgroundImage: 'linear-gradient(180deg, oklch(var(--c-bg-2) / 0.3), oklch(var(--c-bg) / 0.4))' }}
    >
      <div className="mx-auto max-w-[1400px]">
        <ServiceTechniqueNav active={active as ServiceTechniqueNavKey} right={right} />
      </div>
    </nav>
  );
}
